/**
 * Ajusta el query OData de Guías flat antes de enviarlo al API.
 * - `destino_pick` (filtro UI) → `$or` sobre final_destination_name / warehouse_name.
 * - Orden por columna Destino (`destino_pick`) → orden por `final_destination_name` (campo indexable en backend).
 */
export function normalizeGuidesFlatQuery(query) {
	if (!query || typeof query !== 'object') return query;
	const q = JSON.parse(JSON.stringify(query));

	if (q.sort?.length) {
		q.sort = q.sort.map(entry => {
			const [field, order] = String(entry).split(':');
			if (field === 'destino_pick') {
				return `final_destination_name:${order || 'asc'}`;
			}
			return entry;
		});
	}

	const f = q.filters;
	if (!f?.destino_pick) return q;

	const raw = f.destino_pick;
	const val =
		raw && typeof raw === 'object' && '$eqi' in raw ? raw.$eqi : raw;

	delete f.destino_pick;

	if (val == null || val === '') return q;

	f.$or = [
		{ final_destination_name: { $eqi: val } },
		{ warehouse_name: { $eqi: val } },
	];

	return q;
}
